/** Options select « Réf. produit » pour l’admin KKP (catalogue client / Dolibarr). */

const formatProduitPrice = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return `${n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
};

export const formatProduitRefLabel = (produit) => {
  const ref = produit?.product_ref || '';
  const label = produit?.product_label || '';
  if (!ref) return '';
  const base = label && label !== ref ? `${ref} — ${label}` : ref;
  const price = formatProduitPrice(produit?.price_ht);
  return price ? `${base} · ${price}` : base;
};

/**
 * @param {Array<object>} produits
 * @param {Array<string|null|undefined>} [extraRefs]
 * @returns {Array<{ value: string, label: string }>}
 */
export const buildProduitRefOptions = (produits = [], extraRefs = []) => {
  const byRef = new Map();
  produits
    .filter((p) => !p.is_excluded && p.is_tosell && p.product_ref)
    .forEach((p) => {
      byRef.set(String(p.product_ref).toUpperCase(), {
        value: String(p.product_ref).toUpperCase(),
        label: formatProduitRefLabel(p),
      });
    });

  extraRefs.forEach((ref) => {
    const key = String(ref || '').trim().toUpperCase();
    if (!key || byRef.has(key)) return;
    const match = produits.find((p) => String(p.product_ref || '').toUpperCase() === key);
    byRef.set(key, {
      value: key,
      label: match ? formatProduitRefLabel(match) : key,
    });
  });

  return Array.from(byRef.values()).sort((a, b) => a.label.localeCompare(b.label, 'fr'));
};

export const buildProduitRefLabelMap = (options = []) => (
  new Map(options.map((opt) => [opt.value, opt.label]))
);
